import { Component, ElementRef, OnChanges, OnInit, ViewEncapsulation, inject, input, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Environment, ENVIRONMENT_TOKEN } from 'account-hybrid/core/environment.service';
import { buildAzureStoredPhotoUrl } from 'apps/account/src/account-shared/pipes/azure-stored-photo.util';
import { PipesModule } from 'apps/account/src/account-shared/pipes/pipes.module';
import { LegacyShimsModule } from 'apps/account/src/account-shared/legacy-shims/legacy-shims.module';
import { ParseService } from 'apps/account/src/account-shared/services/parse.service';
import { StoryDescriptor } from '../../../../account-v2/src/app/components/broadcast/storyDescriptor';
import { FtImageComponent } from '../../advocacy-group/contest-sheets/ft-image.component';

/**
 * Broadcast image-setup editor — live preview of the share image plus template /
 * toggle controls. `options` is the same object the flow holds and is mutated in
 * place; the template dropdown uses a local `dropdownOpen` flag with outside-click close.
 */
@Component({
    selector: 'ft-story-image-setup-ng',
    imports: [TranslateModule, PipesModule, LegacyShimsModule, FtImageComponent],
    encapsulation: ViewEncapsulation.None,
    templateUrl: './ft-story-image-setup.component.html',
    styleUrls: ['./ft-story-image-setup.component.scss'],
    host: {
        '(document:click)': 'onDocumentClick($event)',
    },
})
export class FtStoryImageSetupComponent implements OnInit, OnChanges {
    readonly story = input<any>();
    readonly property = input<any>();
    /** Two-way in v1 ("="): the SAME object the flow holds — mutated in place. */
    readonly options = input<any>();

    protected quoteSize = 220;
    protected captionSize = 220;

    protected readonly storyDescriptor = signal<StoryDescriptor | undefined>(undefined);
    backgroundPhoto: any;
    protected readonly dropdownOpen = signal(false);

    private readonly parse = inject(ParseService);
    private readonly environment = inject(ENVIRONMENT_TOKEN) as Environment;
    private readonly host = inject(ElementRef) as ElementRef<HTMLElement>;

    protected azurePhoto = (photo: any, size?: string): string =>
        buildAzureStoredPhotoUrl(photo, size, this.environment.AzureCdnBaseUrl) as string;

    ngOnInit(): void {
        this.setup();
    }

    ngOnChanges(): void {
        this.setup();
    }

    private setup(): void {
        if (!this.story() || !this.options()) return;

        this.storyDescriptor.set(new StoryDescriptor(this.parse, this.story()));
        this.backgroundPhoto = this.options().isShowGuestPhoto
            ? this.azurePhoto(this.story().guest.poststay.photo, 'small')
            : this.property().BackgroundImageUrl;
        if (this.options().isShowProfilePic && !this.story().guest.profileImageUrl) {
            this.options().isShowProfilePic = false;
        }
    }

    /** v1 `ft-click-class toggle-class="active"` — any click inside toggles the class. */
    protected toggleDropdown(_event: Event): void {
        this.dropdownOpen.set(!this.dropdownOpen());
    }

    protected onDocumentClick(event: MouseEvent): void {
        if (this.dropdownOpen() && !this.host.nativeElement.contains(event.target as Node)) {
            this.dropdownOpen.set(false);
        }
    }
}
